import Papa from 'papaparse';
import type { CsvRow } from '../types/whatsapp';
import { recipientColumns } from './validateBulkRows';

const CSV_TYPE = 'text/csv';

export function buildRecipientsFile(
  rowsToSend: CsvRow[],
  variableNumbers: number[],
  fileName: string,
): File {
  const columns = recipientColumns(variableNumbers);
  const csvText = Papa.unparse({
    fields: columns,
    data: rowsToSend.map(({ cells }) =>
      columns.map((column) => cells[column] ?? ''),
    ),
  });

  return new File([csvText], fileName, { type: CSV_TYPE });
}
